import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vp-sidebar-items"
}

import VPSidebarItem from '@theme/VPSidebarItem.vue'
import { useSidebarItems } from '@theme/useSidebarItems'
import { onMounted, watch } from 'vue'
import { useRoute } from 'vuepress/client'


export default /*@__PURE__*/_defineComponent({
  __name: 'VPSidebarItems',
  setup(__props) {

const route = useRoute()
const sidebarItems = useSidebarItems()

onMounted(() => {
  watch(
    () => route.hash,
    (hash) => {
      // get the sidebar DOM
      const sidebar = document.querySelector('.vp-sidebar')
      if (!sidebar) return

      // get the active sidebar item DOM, whose href equals to the current route
      const activeSidebarItem = document.querySelector(
        `.vp-sidebar .vp-sidebar-item.auto-link[href="${route.path}${hash}"]`,
      )
      if (!activeSidebarItem) return

      // get the top and height of the sidebar
      const { top: sidebarTop, height: sidebarHeight } =
        sidebar.getBoundingClientRect()
      // get the top and height of the active sidebar item
      const { top: activeSidebarItemTop, height: activeSidebarItemHeight } =
        activeSidebarItem.getBoundingClientRect()

      // when the active sidebar item overflows the top edge of sidebar
      if (activeSidebarItemTop < sidebarTop) {
        // scroll to the top edge of sidebar
        activeSidebarItem.scrollIntoView(true)
      }
      // when the active sidebar item overflows the bottom edge of sidebar
      else if (
        activeSidebarItemTop + activeSidebarItemHeight >
        sidebarTop + sidebarHeight
      ) {
        // scroll to the bottom edge of sidebar
        activeSidebarItem.scrollIntoView(false)
      }
    },
  )
})

return (_ctx: any,_cache: any) => {
  return (_unref(sidebarItems).length)
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sidebarItems), (item) => {
          return (_openBlock(), _createBlock(VPSidebarItem, {
            key: `${item.text}${item.link}`,
            item: item
          }, null, 8, ["item"]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})